module.exports = __webpack_public_path__ + "static/img/pic_video_vip@2x.afd711c2.png";